import React, { useState, useEffect } from "react";
import classes from "./Notification.module.css";
import PaddingContainer from "../../components/PaddingContainer";
import NotificationCard from "../../components/NotificationCard";
import { Announcement, TagIcon } from "../../constant";
import { Row, Col } from "react-bootstrap";
import PromotionCard from "../../components/PromotionCard";
import BannerCard from "../../components/BannerCard";
import AddAnnouncement from "../../modals/Announcements/AddAnnouncement";
import AddOrEditBanner from "../../modals/Announcements/AddOrEditBanner";
import AreYouSureModal from "../../modals/AreYouSureModal";
import { AddCircleIcon } from "../../constant";
import Button from "../../components/Button";
import { Trash } from "../../constant";
// import setPag
import { setPageTitle } from "../../store/pageSlice";
import { useDispatch } from "react-redux";
import useApi from "../../useApi";
import { toast } from "react-toastify";
import Popover from "../../components/Popovers";
import { AeroPlaneIcon } from "../../constant";
import Loader from "../../components/Loader";
const NotificationCenter = () => {
  const {
    addAnnouncement,
    getAnnouncements,
    getNotifications,
    addImages,
    updateImages,
    getBannerImage,
  } = useApi();
  const [notifications, setNotifications] = useState([]);
  const dispatch = useDispatch();
  const [showAddOrEditAnnouncement, setShowAddOrEditAnnouncement] =
    useState(false);
  const [showAddOrEditBannerModal, setShowAddOrEditBannerModal] =
    useState(false);
  const [showAreYouSureModal, setShowAreYouSureModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [announcements, setAnnouncements] = useState([]);
  const [bannerImages, setBannerImages] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    dispatch(setPageTitle("Announcement Center"));
  }, []);

  const bannerMenus = [
    {
      label: "Delete Banner",
      icon: <Trash className={classes.icon} />,
      command: () => {
        setShowAreYouSureModal(true);
      },
    },
  ];

  const addAnnouncementApi = async (params) => {
    const response = await addAnnouncement(params);
    if (response?.data?.headers?.error === 200) {
      setShowAddOrEditAnnouncement(false);
      setAnnouncements((prev) => [...prev, response?.data?.body]);
      toast.success("Announcement added successfully");
    }
    console.log("response", response);
  };

  const getAnnouncementsApi = async (params) => {
    const response = await getAnnouncements(params);
    if (response?.data?.headers?.error === 200) {
      setAnnouncements(response?.data?.body?.items);
    } else {
      toast.error(response?.data?.headers?.message);
    }
  };

  const getNotificationsApi = async (params) => {
    const response = await getNotifications(params);
    if (response?.data?.headers?.error === 200) {
      setNotifications(response?.data?.body?.items);
    } else {
      toast.error(response?.data?.headers?.message);
    }
  };

  const addBannerApi = async (params) => {
    const response = await addImages(params);
    if (response?.data?.headers?.error === 200) {
      toast.success("Banner added successfully");
    } else {
      toast.error(response?.data?.headers?.message);
    }
  };
  // Function to resend a specific announcement
  const resendAnnouncement = (announcement) => {
    setShowAddOrEditAnnouncement(true);
    setSelectedData(announcement);
  };

  const deleteBannerApi = async (params) => {
    const response = await updateImages(params);
    if (response?.data?.headers?.error === 200) {
      toast.success("Banner deleted successfully");
      setBannerImages(
        bannerImages.filter(
          (banner) => banner.companyImageId !== selectedData?.companyImageId
        )
      );
      setShowAreYouSureModal(false);
      setSelectedData(null);
    } else {
      toast.error(response?.data?.headers?.message);
    }
  };
  const getBannerImageApi = async (params) => {
    try {
      const response = await getBannerImage(params);
      if (response?.data?.headers?.error === 200) {
        setBannerImages(response?.data?.body?.homeBannerImages);
      } else {
        toast.error(response?.data?.headers?.message);
      }
    } catch (error) {
      toast.error(error?.message);
    }
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      const result = await Promise.allSettled([
        getBannerImageApi({
          companyDetailID: 1,
        }),
        getAnnouncementsApi({
          id: null,
          search: "",
          pageNumber: 1,
          pageSize: 100000,
          showInactive: false,
          showUpcoming: true,
        }),
      ]);
      setLoading(false);
    })();
  }, []);

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <PaddingContainer style={{ height: "calc(100% - 105px)" }}>
            <section className={classes.topSection}>
              <h2 className={classes.mainHeading}></h2>
              <menu className={classes.menu}>
                <Button
                  className={classes.addButton}
                  label="Add Announcement"
                  leftIcon={<AddCircleIcon />}
                  onClick={() => {
                    setShowAddOrEditAnnouncement(true);
                    setSelectedData(null);
                  }}
                />
                <Button
                  className={classes.secondaryAddButton}
                  label="Add Banner"
                  leftIcon={
                    <AddCircleIcon className={classes.secondaryAddIcon} />
                  }
                  onClick={() => {
                    setShowAddOrEditBannerModal(true);
                  }}
                />
              </menu>
            </section>
            <section className="">
              <Row className={classes.gridOfPromotionsAndAnnouncement}>
                <Col md={8}>
                  <h3 className={classes.heading}>
                    List of Promotions & Announcements
                  </h3>
                  <div className={classes.promotionCardContainer}>
                    {announcements?.map((announcement) => {
                      // Create items array specific to this announcement
                      const announcementItems = [
                        {
                          label: "Resend",
                          icon: <AeroPlaneIcon className={classes.icon} />,
                          command: () => {
                            // Now we have access to the current announcement
                            resendAnnouncement(announcement);
                          },
                        },
                      ];

                      return (
                        <PromotionCard
                          key={announcement.id}
                          data={announcement}
                          menuList={<Popover items={announcementItems} />}
                        />
                      );
                    })}
                  </div>
                </Col>
                <Col md={4}>
                  <h3 className={classes.heading}>Banner Announcements</h3>
                  <div className={classes.promotionCardContainer}>
                    {bannerImages?.map((bannerImage) => {
                      console.log("bannerImages", bannerImage);
                      return (
                        <BannerCard
                          menus={[
                            {
                              label: "Delete Banner",
                              icon: <Trash className={classes.icon} />,
                              command: () => {
                                setSelectedData(bannerImage);
                                setShowAreYouSureModal(true);
                              },
                            },
                          ]}
                          img={bannerImage?.companyImage}
                        />
                      );
                    })}
                  </div>
                </Col>
              </Row>
            </section>
          </PaddingContainer>
          {showAddOrEditBannerModal && (
            <AddOrEditBanner
              onSubmit={addBannerApi}
              show={showAddOrEditBannerModal}
              setShow={setShowAddOrEditBannerModal}
            />
          )}
          {showAddOrEditAnnouncement && (
            <AddAnnouncement
              data={selectedData}
              show={showAddOrEditAnnouncement}
              setShow={setShowAddOrEditAnnouncement}
              onSubmit={addAnnouncementApi}
            />
          )}
          {showAreYouSureModal && (
            <AreYouSureModal
              title="Banner"
              show={showAreYouSureModal}
              setShow={setShowAreYouSureModal}
              onConfirm={() =>
                deleteBannerApi({
                  images: [
                    {
                      companyImageId: selectedData?.companyImageId,
                      companyImage: selectedData?.companyImage,
                      delete: true,
                    },
                  ],
                })
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default NotificationCenter;
